<template>
<img :src="path" :alt="alt" v-if="src" />
</template>

<script>
import VueTypes from 'vue-types'
import utils from '../../util/index'

/**
 * 图片
 * @module component/ArticleImage
 * @example <ArticleImage :src="imageUrl" :info="imagePoint" :width="420" :height="312" size="big" />
 */
export default {
  name: 'article-image',
  components: {
  },
  /**
   * 传入数据
   * @prop {String} size          图片尺寸 [big, small]
   * @prop {String} src           图片地址
   * @prop {String} info          图片选区的坐标，默认为 toString 过得 JSON 数据
   * @prop {Object} info.point    坐标
   * @prop {Number} info.point.x  x 轴坐标
   * @prop {Number} info.point.y  y 轴坐标
   * @prop {Number} info.point.w  水平宽度半径
   * @prop {Number} info.point.h  垂直高度半径
   * @prop {Number} info.width    原图宽度
   * @prop {Number} info.height   原图高度
   * @prop {Number} width         图片宽度
   * @prop {Number} height        图片高度
   * @prop {Number} type          内容类型 目前只针对视频类型返回原图就可以，视频的图片没有 point 数据 [1: 文章  8: 电子书  16: 话题  24: 视频  60: 专题 65: 合辑]
   */
  props: {
    size: VueTypes.oneOf(['small', 'big']).def('small'),
    alt: VueTypes.string.def(''),
    src: VueTypes.string.def(''),
    info: VueTypes.string.def(''),
    width: VueTypes.number.def(0),
    height: VueTypes.number.def(0),
    type: VueTypes.number.def(1)
  },
  data () {
    return {
    }
  },
  computed: {
    /**
     * string to JSON
     */
    pointData () {
      if (!this.info) {
        return {}
      }

      const info = JSON.parse(this.info)
      const point = info[this.size] ? info[this.size].point : info.point

      return {
        point,
        width: info.width,
        height: info.height
      }
    },
    /**
     * 整理后的图片地址后缀
     */
    path () {
      if (!this.pointData.point) {
        if (this.width && this.height) {
          return utils.image(this.src, {
            resize: {
              w: this.width,
              h: this.height
            }
          })
        } else {
          return this.src
        }
        // return require('../../assets/img/article-placeholder-image.jpg')
      }

      const { point, width, height } = this.pointData
      const center = {
        x: (point.x + point.w / 2) | 0,
        y: (point.y + point.h / 2) | 0
      }

      // cdn 裁剪参数
      let x = point.x
      let y = point.y
      let w = point.w
      let h = point.h

      // 按照宽度或高度计算基础比例
      const scaleW = this.width / this.height
      // let scaleH = this.height / this.width

      // 按照高度比例计算实际裁剪的宽度
      let halfW = h * scaleW / 2 | 0

      // 按照宽度比例计算实际裁剪的高度
      let halfH = w / scaleW / 2 | 0

      // 按比例计算后的高度小于原图尺寸时，以宽度为基础进行计算
      if (halfH * 2 <= height) {
        h = halfH * 2
        halfW = w / 2 | 0
      // 需要以高度为基础，计算
      } else {
        w = halfW * 2
        halfH = h / 2 | 0
      }

      // 未超出原图边界时
      if (halfH <= center.y && halfH + center.y <= height) {
        y = center.y - halfH
      } else {
        // 中心点距离顶部比较近时 ? 中心点距离底部比较近时
        y = halfH > center.y ? 0 : height - halfH * 2
      }

      // 未超出原图边界时
      if (halfW <= center.x && halfW + center.x <= width) {
        x = center.x - halfW
      } else {
        // 中心点距离顶部比较近时 ? 中心点距离底部比较近时
        x = halfW > center.x ? 0 : width - halfW * 2
      }

      // return `${this.src}?x-oss-process=image/crop,x_${x},y_${y},w_${w},h_${h}/resize,w_${this.width},h_${this.height}`
      return utils.image(this.src, {
        crop: { x, y, w, h },
        resize: {
          w: this.width,
          h: this.height
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

</style>
